import React from 'react';

interface BoundaryBandProps {
  text?: string;
}

export function BoundaryBand({ text }: BoundaryBandProps) {
  return (
    <div
      className="flex items-center gap-3 px-4 py-2 rounded-lg text-xs text-white"
      style={{ background: 'linear-gradient(90deg, #0E9D8A 0%, #0B7A6A 100%)' }}
    >
      <div className="flex-1 h-px bg-white/30" />
      {text && <span className="shrink-0 font-medium text-center max-w-xl">{text}</span>}
      <div className="flex-1 h-px bg-white/30" />
    </div>
  );
}
